import {
    apiRequest,
    riwayatjabatanList,
    riwayatjabatanActive,
    riwayatjabatanInactive
} from "../../../../../services/adapters/kepegawaian/riwayatjabatanService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", riwayatjabatanList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", riwayatjabatanInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", riwayatjabatanActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository